var __TEMP__ = require('./_getMapData.js');var getMapData = __REQUIRE_DEFAULT__(__TEMP__);

/**
 * Gets the map value for `key`.
 *
 * @private
 * @name get
 * @memberOf MapCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function mapCacheGet(key) {
  return getMapData(this, key).get(key);
}

if (!exports.__esModule) Object.defineProperty(exports, "__esModule", { value: true });exports.default = mapCacheGet;
